// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"3aa7ca21","998":"5c4d893c"}[chunkId] + ".chunk.css";
};